module.exports = __webpack_public_path__ + "assets/currentLocation-c05db4.svg";